import http from "./http";

/*
|--------------------------------------------------------------------------
| Dashboard API Services
|--------------------------------------------------------------------------
| Matches
| Users
| Revenue (Question Bets)
| NEW:
| Bets Dashboard
| C Selection Settlement
| Points Game Report
|--------------------------------------------------------------------------
*/

const dashboardServices = {

    /* ------------------------------------------
       1. Match Statistics
    -------------------------------------------*/
    getMatchStats: async () => {
        try {
            const res = await http.get("dashboard/matches");
            return res.data;
        } catch (error) {
            console.error("Error fetching match stats:", error);
            throw error.response?.data || { message: "Network Error" };
        }
    },

    /* ------------------------------------------
       2. User Statistics
    -------------------------------------------*/
    getUserStats: async () => {
        try {
            const res = await http.get("dashboard/user-number");
            return res.data;
        } catch (error) {
            console.error("Error fetching user stats:", error);
            throw error.response?.data || { message: "Network Error" };
        }
    },

    /* ------------------------------------------
       3. Revenue Statistics (Old)
    -------------------------------------------*/
    getRevenueStats: async () => {
        try {
            const res = await http.get("dashboard/question_bets_dashboard");
            return res.data;
        } catch (error) {
            console.error("Error fetching revenue stats:", error);
            throw error.response?.data || { message: "Network Error" };
        }
    },

    /* ------------------------------------------
       4. Bets Dashboard (NEW)
    -------------------------------------------*/
    getBetsDashboard: async () => {
        try {
            const res = await http.get("dashboard/bets_dashboard");
            return res.data;
        } catch (error) {
            console.error("Error fetching bets dashboard:", error);
            throw error.response?.data || { message: "Network Error" };
        }
    },

    /* ------------------------------------------
       5. C Selection Settlement Dashboard (NEW)
    -------------------------------------------*/
    getCSelectionDashboard: async () => {
        try {
            const res = await http.get("dashboard/C-selection_settlement_dashboard");
            return res.data;
        } catch (error) {
            console.error("Error fetching C selection dashboard:", error);
            throw error.response?.data || { message: "Network Error" };
        }
    },

    /* ------------------------------------------
       6. Points Game Report (NEW)
    -------------------------------------------*/
    getPointsGameReport: async () => {
        try {
            const res = await http.get("dashboard/points_game_report");
            return res.data;
        } catch (error) {
            console.error("Error fetching points game report:", error);
            throw error.response?.data || { message: "Network Error" };
        }
    }

};

export default dashboardServices;